import { faThumbtack } from "@fortawesome/free-solid-svg-icons/faThumbtack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { HistoricoFiltro } from "app/api/classes/ProdutoApi";
import globalMU from "globalMU";
import React from "react";
const estiloPesquisarAnteriores =
  require("./pesquisas-anteriores.module.scss").default;

export type FiltroPesquisaAnteriores = {
  checkFiltrarCliente: boolean;
  codigoCliente: number;
  idFiltro: number;
  vendedorId: string;
};

export type PesquisasAnterioresProps = {
  mostrarCampoFiltrarCliente: boolean;
  pesquisasAnteriores: HistoricoFiltro[];
  onCheckPesquisar: (checkFiltrarCliente: boolean) => void;
  onSelecionar: (idFiltro: number) => void;
  onPesquisar: (filtros: string) => void;
};

export const PesquisasAnteriores = (props: PesquisasAnterioresProps) => {
  return (
    <div id="pesquisar-historico-filtros-region">
      <fieldset
        id="fieldset-historico-filtro-filtros"
        className={`mt-2 ${estiloPesquisarAnteriores.fieldsetLabelFilterHistory}`}
      >
        {
          props.mostrarCampoFiltrarCliente && (
            <div className={estiloPesquisarAnteriores.checkboxFilterClient}>
              <label>Filtrar o cliente</label>
              <input
                type="checkbox"
                name="FiltrarCliente"
                id="HistoricoFiltro_FiltrarCliente"
                onChange={(e) => props.onCheckPesquisar(e.target.checked)}
              />
            </div>
          )}
      </fieldset>
      <div className="_table _w-full _border-collapse">
        <div className="_table-header-group ">
          <div className="_table-row">
            <div
              className={`_table-cell ${estiloPesquisarAnteriores.tableCellHeader}`}
            ></div>
            <div
              className={`_table-cell _font-bold ${estiloPesquisarAnteriores.tableCellHeader}`}
            >
              Data
            </div>
            <div
              className={`_table-cell _font-bold ${estiloPesquisarAnteriores.tableCellHeader}`}
            >
              Filtro
            </div>
          </div>
        </div>
        <div className="_table-row-group">
          {props.pesquisasAnteriores?.map((value) => (
            <div
              key={value.Id}
              className={`_table-row _cursor-pointer ${estiloPesquisarAnteriores.tableBody}`}
            >
              <div
                className={`_table-cell _text-center ${estiloPesquisarAnteriores.tableCellBody}`}
              >
                <FontAwesomeIcon
                  style={
                    value.SelecionadoClass === "icone-pin ativo"
                      ? { opacity: 1 }
                      : { opacity: 0.2 }
                  }
                  cursor="pointer"
                  color="#80888a"
                  transform="rotate-45"
                  icon={faThumbtack}
                  onClick={() =>
                    props.onSelecionar(value.Id)
                  }
                />
              </div>
              <div
                className={`_table-cell ${estiloPesquisarAnteriores.tableCellBody}`}
                onClick={() => props.onPesquisar(value.Filtro)}
              >
                {globalMU.formatDateTime(value.Data)}
              </div>
              <div
                className={`_table-cell ${estiloPesquisarAnteriores.tableCellBody}`}
                onClick={() => props.onPesquisar(value.Filtro)}
              >
                {value.FiltroFormatado}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
